<template>
  <div>
    <el-dialog
      title="判卷记录"
      width="740px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-table v-loading="loading" :data="list" style="width:100%" border>
        <el-table-column label="操作人" width="120" align="center">
          <template v-slot="{ row }">
            <span>{{ row.insertByName || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作时间" min-width="158" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="总分" min-width="100" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.practicalScore || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="得分情况" min-width="100" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="mini" @click="viewDetail(row)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column label="修改内容" min-width="200" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.teacherComment || '--' }}</span>
          </template>
        </el-table-column>
      </el-table>
      <br>
      <el-pagination
        @size-change="handlePageSize"
        @current-change="handlePage"
        :current-page="pageInfo.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageInfo.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageInfo.total"
      />
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关 闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="得分情况" :visible.sync="dialogDetailVisible" width="480px" append-to-body>
      <el-table :data="gridData" :show-header="false">
        <el-table-column prop="label" align="right" width="120" />
        <el-table-column prop="value" align="right" width="150" />
        <el-table-column prop="unit" align="left" width="120" />
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogDetailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getGradingListPage } from "@/api/product/testPlanItem"

export default {
  name: 'Record',

  data () {
    return {
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0
      },
      dialogVisible: false,
      loading: false,
      list: [],
      dialogDetailVisible: false,
      gridData: []
    }
  },
  methods: {
    init (id) {
      this.pageInfo.userPracticalId = id
      this.getListPage()
      this.dialogVisible = true
    },
    getListPage() {
      this.loading = true
      getGradingListPage(this.pageInfo).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.pageInfo.total = parseInt(data.total)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    viewDetail (row) {
      this.gridData = [
        { label: '内容创作：', value: `${row.practicalContentCreation}/10`, unit: '得分/总分' },
        { label: '语言表达：', value: `${row.practicalLanguageExpression}/30`, unit: '得分/总分' },
        { label: '镜头表现：', value: `${row.practicalScreenPresence}/30`, unit: '得分/总分' },
        { label: '数据分析：', value: `${row.practicalDataAnalysis}/20`, unit: '得分/总分' },
        { label: '策划运营：', value: `${row.practicalPlanOperation}/10`, unit: '得分/总分' },
        { label: '得分：', value: `${row.practicalScore}/100`, unit: '得分/总分' },
      ]
      this.dialogDetailVisible = true
    },
    handleClose () {
      this.pageInfo = this.$options.data().pageInfo
      this.list = []
      this.dialogVisible = false
    },
    handlePage(current) {
      this.pageInfo.page = current
      this.getListPage()
    },
    handlePageSize(size) {
      this.pageInfo.limit = size
      this.getListPage()
    },
  }
}
</script>

<style>

</style>
